import React from 'react';
import { Box, Typography, Paper, Container, Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/DomainContext';
import { Link as RouterLink } from 'react-router-dom';
const UserDashboard = () => {
  const { profile } = useAuth();
  const { projectName, primaryColor } = useBranding();

  const displayName = profile?.user_display_name || 'Utente';

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          borderTop: `5px solid ${primaryColor || '#1976d2'}`,
          borderRadius: 2 
        }}
      >
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ color: primaryColor || 'text.primary', fontWeight: 'bold' }}
        >
          Dashboard Utente
        </Typography>
        
        <Typography variant="h6" sx={{ mb: 2 }}>
          Benvenuto, {displayName}!
        </Typography>
        
        <Typography variant="body1" color="text.secondary">
          Questa è la tua area personale per il progetto: <strong>{projectName}</strong>.
        </Typography>
        
        {/* --- BOTTONE PER ACCEDERE ALLA CHAT AI --- */}
        <Box mt={4} mb={2}>
          <Button
            variant="contained"
            color="secondary"
            component={RouterLink}
            to="/agents/chat"
            sx={{ fontWeight: 'bold', borderRadius: 2 }}
          >
            Vai alla Chat AI
          </Button>
        </Box>
        
        <Box mt={2}>
          <Typography variant="h5">I tuoi dati:</Typography>
          <pre style={{ background: '#f5f5f5', padding: '1rem', borderRadius: '8px', whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(profile, null, 2)}
          </pre>
        </Box>
      </Paper>
    </Container>
  );
};

export default UserDashboard;
